import { render, staticRenderFns } from "./MediaLibrary.vue?vue&type=template&id=05742dc9&scoped=true&"
import script from "./MediaLibrary.vue?vue&type=script&lang=ts&"
export * from "./MediaLibrary.vue?vue&type=script&lang=ts&"
import style0 from "./MediaLibrary.vue?vue&type=style&index=0&id=05742dc9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05742dc9",
  null
  
)

export default component.exports